import { Company } from "@/modules/companies/interfaces/company";
import { options } from "floating-vue";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useCompanyStore = defineStore("company", () => {
  const company = ref<Company>();
  const id = ref<number | undefined>();

  return {
    company,
    id,

    setId(value: number | undefined) {
      id.value = value;
    },
    setCompany(value: Company | undefined) {
      company.value = value;
    },
  };
});
